import React from 'react';
import '../styles/global.css';
import ThemeToggle from '../components/ThemeToggle';
import { motion } from 'framer-motion';

function About() {
  return (
    <div className="app">
      <header className="hero-header">
        <div className="container">
          <h1>About My Abnormal Story</h1>
        </div>
      </header>

      <main className="container">
        <section className="about-section">
          <div className="card">
            <div className="mission">
              <h2>Our Mission</h2>
              <p>My Abnormal Story exists to create a trusted space where cancer survivors can share alternative treatment journeys, providing hope and information to others seeking options beyond traditional approaches.</p>
            </div>
            
            <div className="story">
              <h2>How We Started</h2>
              <p>This platform was born from witnessing the gaps in traditional cancer care systems and recognizing that many survivors have valuable experiences that could help others.</p>
              
              <p>My Abnormal Story isn't about rejecting conventional medicine, but about expanding the conversation to include approaches that may not receive adequate attention in mainstream healthcare settings.</p>
            </div>
            
            <div className="values">
              <h2>Our Core Values</h2>
              <ul>
                <li><strong>Authenticity:</strong> Real stories from real people without corporate influence</li>
                <li><strong>Privacy:</strong> Respecting the sensitive nature of personal health information</li>
                <li><strong>Hope:</strong> Focusing on positive outcomes while acknowledging challenges</li>
                <li><strong>Accessibility:</strong> Making information available to anyone who needs it</li>
                <li><strong>Scientific curiosity:</strong> Using collective experiences to identify patterns worth researching</li>
              </ul>
            </div>
          </div>
        </section>
        <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.8, duration: 0.5 }}
      >
        <ThemeToggle />
      </motion.div>
      </main>

      <footer className="site-footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-info">
              <p>© {new Date().getFullYear()} My Abnormal Story</p>
              <p className="footer-tagline">
                Sharing alternative cancer treatment journeys to inspire hope
              </p>
            </div>
            <div className="footer-links">
              <a href="/" className="admin-link">Home</a>
              <a href="/privacy" className="admin-link">Privacy</a>
              <a href="/resources" className="admin-link">Resources</a>
              <a href="/admin-login" className="admin-link">Admin</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default About;